import { render } from "./TermsOfService.vue?vue&type=template&id=1dc1ef38&scoped=true"
import script from "./TermsOfService.vue?vue&type=script&lang=js"
export * from "./TermsOfService.vue?vue&type=script&lang=js"

import "./TermsOfService.vue?vue&type=style&index=0&id=1dc1ef38&scoped=true&lang=css"

import exportComponent from "/home/runner/work/company-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc1ef38"]])

export default __exports__